import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { IDTransactionLog, TransactionStatus } from 'realhaus-sdk';
import { RootStoreContext } from '../../global/storeContext';
import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { AdminDrawer, IAnchorType } from '../uiComponent/drawer';
import { PayoutDrawer } from './drawers/payoutDrawer';
import StringUtils from '../../utils/string';
export const Payouts: React.FC = observer(() => {
    const [withdrawRequests, setWithdrawRequests] = React.useState<IDTransactionLog[]>([]);
    const [cursor, setCursor] = React.useState<{ id: string; timestamp: number }>();
    const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false);
    const { uiStore, dashboardStore } = React.useContext(RootStoreContext);
    const [selectedRequestId, setSelectedRequestId] = React.useState<string>();

    const getWithdrawalRequests = () => {
        uiStore.showLoading();
        dashboardStore
            .getPayouts(cursor)
            .then((data) => {
                if (data) {
                    let requests = [...withdrawRequests];
                    data.trxLogs.map((t) => {
                        if (requests.find((r) => r.id === t.id)) return;
                        requests.push(t);
                    });
                    setWithdrawRequests(requests);
                    setCursor(data.cursor);
                } else {
                    uiStore.error('No payout requests');
                }
            })
            .catch((err) => {
                uiStore.error('Could not fetch payout requests');
                console.log(err);
            })
            .finally(() => {
                uiStore.hideLoading();
            });
    };

    const handleDrawerOpen = (trxlogId: string) => {
        setSelectedRequestId(trxlogId);
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setSelectedRequestId(undefined);
        setDrawerOpen(false);
    };

    useEffect(() => {
        getWithdrawalRequests();
    }, []);

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell align='right'>Amount</TableCell>
                            <TableCell align='right'>Status</TableCell>
                            <TableCell align='right'>UserId</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {withdrawRequests.map((trxLog) => (
                            <TableRow
                                key={trxLog.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                onClick={() => handleDrawerOpen(trxLog.id)}
                            >
                                <TableCell component='th' scope='row'>
                                    {StringUtils.getDateTimeFormat(trxLog.timestamp)}
                                </TableCell>
                                <TableCell align='right'>{trxLog.amount}</TableCell>
                                <TableCell align='right'>{trxLog.status}</TableCell>
                                <TableCell align='right'>{trxLog.senderId}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell align='center' colSpan={4}>
                                <Button disabled={!cursor} onClick={getWithdrawalRequests}>
                                    ...Load more
                                </Button>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <AdminDrawer type={IAnchorType.RIGHT} open={drawerOpen} onClose={handleDrawerClose}>
                <PayoutDrawer
                    trxLogId={selectedRequestId!}
                    request={withdrawRequests.find((r) => r.id === selectedRequestId)!}
                    onPayoutComplete={() => {
                        const r = withdrawRequests.find((r) => r.id === selectedRequestId);
                        if (r) {
                            r.status = TransactionStatus.SUCCESS;
                        }
                    }}
                />
            </AdminDrawer>
        </>
    );
});
